import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchSettingsMemberships } from '../services/workspaceSettingsService';
import type { WorkspaceSettingsState } from '../types/workspace.types';

const initialState: WorkspaceSettingsState = {
  memberships: [],
  isLoading: false,
  error: null,
};

export const loadMemberships = createAsyncThunk(
  'settings/workspaces/load',
  async () => {
    return await fetchSettingsMemberships();
  }
);

const workspaceSettingsSlice = createSlice({
  name: 'settingsWorkspaces',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadMemberships.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loadMemberships.fulfilled, (state, action) => {
        state.isLoading = false;
        state.memberships = action.payload;
      })
      .addCase(loadMemberships.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? 'Failed to load memberships';
      });
  },
});

export const workspaceSettingsReducer = workspaceSettingsSlice.reducer;
